import './App.css';
import Configurator from './Configurator';

function App() {
  return (
    <div className="App vh-100">
      <header className="App-header">
      </header>
      <main className='bg-dark'>
        < Configurator />
      </main>
    </div>
  );
}

export default App;
